import React, { memo, useCallback, useMemo } from "react";
import Surface from "./Surface";
import { SurfaceRoundedCard } from "./SurfacesCoreUI";

import SURVEY_SURFACE_IMAGE from "../../img/survey-surface.png";
import SurveyCard from "../SurveyCard";

import "./survey-surface.css";
import { eventTypes } from "../../hooks/useTrack";
import { PostPurchaseExtensionPreview } from "../CoreUI";
import inExtensionPreview from "../../utils/inExtensionPreview";
import useData from "../../hooks/useData";
import accessibilityProvider from "../../utils/accessibilityProvider";
// import { DEFAULT_SHOP_IMG } from "../../conf";

const SurveySurface = memo(
	({
		surfaceData,
		idx,
		handleSurfaceClose,
		handleOrchestratorClose,
		showFullCard,
	}) => {
		const {
			question_text: question,
			remote_id: question_id,
			module_order,
		} = useMemo(
			() => ({
				...surfaceData,
			}),
			[surfaceData]
		);

		const data = useData();

		const handleClose = useCallback(() => {
			handleSurfaceClose();
		}, [handleSurfaceClose]);

		const displayEvent = useMemo(
			() => ({
				name: eventTypes.WIDGET_SURFACE_SURVEY_DISPLAY,
				properties: {
					question,
					question_id,
					module_position: idx,
					module_order,
				},
			}),
			[question, question_id, idx, module_order]
		);

		const skipEvent = useMemo(
			() => ({
				name: eventTypes.WIDGET_SURFACE_SURVEY_SKIP,
				properties: {
					question,
					question_id,
					module_position: idx,
					module_order,
				},
			}),
			[question, question_id, idx, module_order]
		);

		if (inExtensionPreview) {
			return (
				<PostPurchaseExtensionPreview
					surfaceData={{
						...surfaceData,
					}}
					type="survey"
					handleClose={handleClose}
				/>
			);
		}

		return (
			<Surface
				handleClose={handleOrchestratorClose}
				imageView={{
					imgUrl: SURVEY_SURFACE_IMAGE,
					hidePrimaryImg: true,
					showBrandLogo: true,
					showBrandColor: true,
					heightScale: 3.25,
					// hidden: inDesktopOnly ? true : false,
					data,
				}}
				hideActionBar
				displayEvent={displayEvent}
				skipEvent={skipEvent}
				showSurfaceTab={false}
				showFullCard={showFullCard}
				// USING A REALLY LARGE NUMBER AND NOT INFINITY FOR CSS COMPATIBILITY
				// offsetTopScale={inDesktopOnly ? 100000000 : 3.8}
				offsetTopScale={3.9}
				{...accessibilityProvider({
					disableTabIndex: true,
					role: "group",
					title: "Survey surface",
				})}

				// className={inDesktopOnly ? "survey-surface-container" : ""}
				// showSurfaceBrandLogo={inDesktopOnly}
			>
				<SurfaceRoundedCard
					showFullCard={showFullCard}
					{...accessibilityProvider({
						disableTabIndex: true,
						role: "group",
						title: "Survey surface card",
					})}
				>
					{/* {inDesktopOnly && (
						<img
							className="survey-surface-brand-logo"
							src={
								data?.publisher_details?.logo_url ||
								DEFAULT_SHOP_IMG
							}
							alt=""
						/>
					)} */}
					{/* <SurfaceTitle>
						{(inDesktopOnly && data?.publisher_details?.name) ||
							"Thank You!"}
					</SurfaceTitle>
					{inDesktopOnly && data?.publisher_details?.single_liner && (
						<div className="survey-surface-description">
							{data.publisher_details.single_liner}
						</div>
					)} */}
					<SurveyCard
						publisher={data?.p || ""}
						survey={surfaceData}
						customerID={data?.u || ""}
						onClose={handleClose}
						cardIdentifier={idx}
						inSurface
						modal
					/>
				</SurfaceRoundedCard>
			</Surface>
		);
	}
);

export default SurveySurface;
